import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// Create an async thunk for fetch voucher redemptions
export const fetchVoucherRedemptionsByUserId = createAsyncThunk('voucherRedemptions/voucherRedemptionsByUserId', async () => {
  const response = await fetch(`/api/vouchers/redemptions/`);
  const data = await response.json();
  return data;
});

const voucherRedemptionsByUserIdSlice = createSlice({
  name: 'voucherRedemptions',
  initialState: { voucherRedemptions: '', status: 'idle', error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchVoucherRedemptionsByUserId.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchVoucherRedemptionsByUserId.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.voucherRedemptions = action.payload;
      })
      .addCase(fetchVoucherRedemptionsByUserId.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  },
});

export default voucherRedemptionsByUserIdSlice.reducer;